import { useToastOpen } from 'contexts/ToastContext';
import { useCallback } from 'react';
import { t } from 'utils/localize';

export default function useToastPromise<T, Args extends any[]>(
  request: (...args: Args) => Promise<T>,
  errorText: string = t('Something went wrong...')
) {
  const toastOpen = useToastOpen();
  return useCallback(
    async (...args: Args) => {
      try {
        return request(...args);
      } catch (e) {
        toastOpen({ label: errorText });
      }
    },
    [errorText, request, toastOpen]
  );
}
